document.addEventListener("DOMContentLoaded", function () {
    const evergreenTimers = document.querySelectorAll(
      ".countdown-mode-evergreen .countdown-timer-block__timer-item"
    );
    if (evergreenTimers.length === 0) return;
  
    const timezoneOffsets = {
      local: 0, 
      UTC: 0,
      EST: -300, 
      CST: -360, 
      MST: -420, 
      PST: -480, 
      GMT: 0,
      IST: 330, 
      JST: 540, 
      AEST: 600, 
      CET: 60, 
    };
  
    function getTimezoneOffset(timezone) {
      if (timezone === "local") {
        return new Date().getTimezoneOffset();
      }
      return -timezoneOffsets[timezone] || 0; 
    }
  
    function getNextResetTime(duration, timezone) {
      const now = new Date();
      const timezoneOffset = getTimezoneOffset(timezone);
      const localOffset = now.getTimezoneOffset();
      const offsetDiff = timezoneOffset - localOffset;
  
      const adjustedNow = new Date(now.getTime() + offsetDiff * 60000);
      const nextReset = new Date(adjustedNow);
  
      switch (duration) {
        case "every_2_hrs":
          nextReset.setHours(Math.ceil(adjustedNow.getHours() / 2) * 2, 0, 0, 0);
          if (nextReset <= adjustedNow) {
            nextReset.setHours(nextReset.getHours() + 2);
          }
          break;
        case "every_6_hrs":
          nextReset.setHours(Math.ceil(adjustedNow.getHours() / 6) * 6, 0, 0, 0);
          if (nextReset <= adjustedNow) {
            nextReset.setHours(nextReset.getHours() + 6);
          }
          break;
        case "every_12_hrs":
          nextReset.setHours(
            Math.ceil(adjustedNow.getHours() / 12) * 12,
            0,
            0,
            0
          );
          if (nextReset <= adjustedNow) {
            nextReset.setHours(nextReset.getHours() + 12);
          }
          break;
        case "every_24_hrs":
          nextReset.setHours(24, 0, 0, 0);
          break;
        case "every_week":
          nextReset.setDate(adjustedNow.getDate() + (7 - adjustedNow.getDay()));
          nextReset.setHours(0, 0, 0, 0);
          break;
        case "every_month":
          nextReset.setMonth(adjustedNow.getMonth() + 1);
          nextReset.setDate(1);
          nextReset.setHours(0, 0, 0, 0);
          break;
        default:
          nextReset.setHours(24, 0, 0, 0);
      }
  
      return new Date(nextReset.getTime() - offsetDiff * 60000);
    }
  
    function updateCountdown() {
      evergreenTimers.forEach((timerItem) => {
        const duration = timerItem.getAttribute("data-duration");
        const timezone = timerItem.getAttribute("data-timezone") || "local";
        const nextReset = getNextResetTime(duration, timezone);
        const now = new Date();
        const timeLeft = nextReset - now;
  
        const daysContainer = timerItem.querySelector(
          ".countdown-days-container"
        );
        if (daysContainer) {
          daysContainer.style.display =
            duration === "every_week" || duration === "every_month"
              ? "flex"
              : "none";
        }
  
        if (timeLeft <= 0) {
          const newNextReset = getNextResetTime(duration, timezone);
          const newTimeLeft = newNextReset - now;
          updateTimerDisplay(timerItem, newTimeLeft, duration);
        } else {
          updateTimerDisplay(timerItem, timeLeft, duration);
        }
      });
    }
  
    function updateTimerDisplay(timerItem, timeLeft, duration) {
      const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);
  
      const daysElement = timerItem.querySelector(".countdown-days-value");
      const hoursElement = timerItem.querySelector(".countdown-hours");
      const minutesElement = timerItem.querySelector(".countdown-minutes");
      const secondsElement = timerItem.querySelector(".countdown-seconds");
  
      if (
        daysElement &&
        (duration === "every_week" || duration === "every_month")
      ) {
        daysElement.textContent = days.toString().padStart(2, "0");
      }
      if (hoursElement)
        hoursElement.textContent = hours.toString().padStart(2, "0");
      if (minutesElement)
        minutesElement.textContent = minutes.toString().padStart(2, "0");
      if (secondsElement)
        secondsElement.textContent = seconds.toString().padStart(2, "0");
    }
  
    updateCountdown();
    setInterval(updateCountdown, 1000);
  });
  